import { searchWithinStyles } from "@insite/content-library/Widgets/ProductList/ProductListSearchWithin";
import Search from "@insite/mobius/Icons/Search";
import merge from "lodash/merge";
import { css } from "styled-components";

Object.assign(searchWithinStyles, {
    titleText: {
        variant: "h6",
        css: css`
            width: 100%;
            padding: 0 15px;
            color: #333333;
            font-size: 16px !important;
            margin-bottom: 0;
            font-weight: 700;
        `,
    },
    searchTextField: {
        iconProps: { src: Search },
        cssOverrides: {
            formField: css`
                width: 100%;
                padding: 15px 15px 0 15px;
            `,
            inputSelect: css`
                padding-right: 33px !important;
                border-radius: 21px !important;
                overflow-wrap: break-word !important;
                word-break: break-all !important;
                &:focus {
                    border-radius: 21px;
                }
            `,
        },
    },
    wrapper: {},
});
